import initialState from "./initalState";
import reducers from '../reducers'
import configureStore, { history } from "./configureStore";

export default configureStore(reducers(history), {...initialState})